import _ from 'lodash';
import { useContext } from 'react';
import { WizardContext } from '@xengage/gw-portals-wizard-react';

function useCheckRewriteSteps() {
    const wizardContext = useContext(WizardContext);
    const {
        steps, wizardData, changeNextSteps, currentStepIndex
    } = wizardContext || {};

    const _hasFormToBeSigned = (forms) => {
        return forms.value && forms.value.some((form) => {
            return form.esigned_ML === true && form.isSigned === false;
        });
    };


    /**
     * Can be used to check if steps 'rewriteRequiredSignatures' and 'rewriteAvailableDocuments'
     * are visible. This function WILL NOT change those steps visibility.
     * @param {Object} submissionVM optional, will use wizard context's data if undefined
     * @returns {Boolean} 
     */
    const hasFormToBeSigned = (submissionVM) => {
        if(submissionVM){
            return _hasFormToBeSigned(_.get(submissionVM, 'forms_ML', {}));
        }
        return _hasFormToBeSigned(_.get(wizardData, 'submissionVM.forms_ML', {}));
    }

    const _hasVerbalAuthForms = (forms) => {
        return forms.value && forms.value.find((form) => {
            return !!form.verbalAuthorization_ML;
        });
    };

    /**
     * Can be used to check if steps 'rewriteVerbalAuthorization', 'rewriteRequiredSignatures' and 'rewriteAvailableDocuments'
     * are visible. This function WILL NOT change those steps visibility.
     * @param {Object} submissionVM optional, will use wizard context's data if undefined
     * @returns {Boolean} 
     */
    const hasVerbalAuthForms = (submissionVM) => {
        if(submissionVM){
            return _hasVerbalAuthForms(_.get(submissionVM, 'forms_ML', {}));
        }
        return _hasVerbalAuthForms(_.get(wizardData, 'submissionVM.forms_ML', {}));
    }


    /**
     * Used in RewriteWizard's pages to check if steps 'rewriteVerbalAuthorization', 'rewriteRequiredSignatures' and 'rewriteAvailableDocuments'
     * are needed (and visible on sidebar). This function will change steps visibility.
     * @param {Object} submissionVM optional, will use wizard context's data if undefined
     */
    const checkSteps = (submissionVM) => {
        if(hasVerbalAuthForms(submissionVM)){
            const newSteps = steps.slice(currentStepIndex+1)
            const rewriteVerbalAuthorization = _.find(newSteps, { 'id': 'rewriteVerbalAuthorization'});
            rewriteVerbalAuthorization.stepHidden = false;
            const rewriteRequiredSignatures = _.find(newSteps, { 'id': 'rewriteRequiredSignatures'});
            rewriteRequiredSignatures.stepHidden = false;
            const rewriteAvailableDocuments = _.find(newSteps, { 'id': 'rewriteAvailableDocuments'});
            rewriteAvailableDocuments.stepHidden = false;
            changeNextSteps(newSteps);
        }

        if(hasFormToBeSigned(submissionVM)){
            const newSteps = steps.slice(currentStepIndex+1)
            const rewriteRequiredSignatures = _.find(newSteps, { 'id': 'rewriteRequiredSignatures'});
            rewriteRequiredSignatures.stepHidden = false;
            const rewriteAvailableDocuments = _.find(newSteps, { 'id': 'rewriteAvailableDocuments'});
            rewriteAvailableDocuments.stepHidden = false;
            changeNextSteps(newSteps);
        }
    }

    /**
     * Used in RewriteWizard to check if steps 'rewriteVerbalAuthorization', 'rewriteRequiredSignatures' and 'rewriteAvailableDocuments'
     * are needed (and visible on sidebar). This function will change steps visibility.
     * @param {Object} _submissionVM 
     * @param {Array} _steps 
     */
    const checkStepsAtWizard = (_submissionVM, _steps) => {
        if(hasVerbalAuthForms(_submissionVM)){
            const rewriteVerbalAuthorization = _.find(_steps, { 'id': 'rewriteVerbalAuthorization'});
            rewriteVerbalAuthorization.stepHidden = false;
            const rewriteRequiredSignatures = _.find(_steps, { 'id': 'rewriteRequiredSignatures'});
            rewriteRequiredSignatures.stepHidden = false;
            const rewriteAvailableDocuments = _.find(_steps, { 'id': 'rewriteAvailableDocuments'});
            rewriteAvailableDocuments.stepHidden = false;
        }

        if(hasFormToBeSigned(_submissionVM)){
            const rewriteRequiredSignatures = _.find(_steps, { 'id': 'rewriteRequiredSignatures'});
            rewriteRequiredSignatures.stepHidden = false;
            const rewriteAvailableDocuments = _.find(_steps, { 'id': 'rewriteAvailableDocuments'});
            rewriteAvailableDocuments.stepHidden = false;
        }
    }

    return {
        checkSteps,
        checkStepsAtWizard,
        hasFormToBeSigned,
        hasVerbalAuthForms
    }
}

export default useCheckRewriteSteps;